export default function (state = [], action) {
  switch (action.type) {
    case "SELECT_CURRENCIES":
      return action.payload;
      break;
    default:
      return state;
  }
}
